module.exports = __webpack_public_path__ + "assets/img/de04cae6843a921682877334a4b454cd.svg";